import { useNavigate } from 'react-router';
import { Button } from '@monksflow/monks-ui';
import { PlusIcon } from 'lucide-react';
import { ROUTES } from '@/shared/config/routes';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '@/shared/ui/EmptyState';

export const AnalysisEmptyState = () => {
  const { t } = useTranslation('analysis');

  const navigate = useNavigate();

  return (
    <EmptyState
      data-testid="analysis-empty-state"
      className="flex-1"
      title={t('analysis.analysisEmptyState.noIqAnalysesGenerated')}
      description={t('analysis.analysisEmptyState.startCreatingYourNewAnalysis')}
    >
      <Button
        size="default"
        data-testid="new-analysis-button"
        onClick={() => void navigate(ROUTES.IQ_NEW_ANALYSIS)}
      >
        <PlusIcon className="size-4" />
        {t('analysis.analysisEmptyState.newIQ')}
      </Button>
    </EmptyState>
  );
};
